<template>
    <div class="urge-wrapper">
        <span class="urge-label">{{promotionLabel}}</span>
        <div class="urge-info">
            <urge-info-time v-if="remainingTime" :remaining-time="remainingTime" :base-timestamp="baseTimestamp" />
            <urge-info-count v-if="remainingCount" :remaining-count="remainingCount" />
        </div>
    </div>
</template>

<script>
import UrgeInfoCount from '@business/components/learn/urge/Count';
import UrgeInfoTime from '@business/components/learn/urge/Time';

export default {
    components: {
        'urge-info-count': UrgeInfoCount,
        'urge-info-time': UrgeInfoTime
    },
    props: {
        urgeInfo: {
            type: Object,
            default() {
                return null;
            }
        }
    },
    computed: {
        remainingTime() {
            if (!this.urgeInfo || !this.urgeInfo.promotionCountDown) {
                return 0;
            }
            return this.urgeInfo.promotionCountDown.remainingTime;
        },
        remainingCount() {
            if (!this.urgeInfo || !this.urgeInfo.promotionCountDown) {
                return 0;
            }
            return this.urgeInfo.promotionCountDown.remainingCount;
        },
        baseTimestamp() {
            if (!this.urgeInfo) {
                return 0;
            }
            return this.urgeInfo.promotionBaseTimestamp;
        },
        promotionLabel() {
            if (this.remainingTime) {
                return '限时优惠';
            }
            if (this.remainingCount) {
                return '限额优惠';
            }
            return '';
        }
    }
};
</script>

<style lang="less" scoped>
.urge-wrapper {
    display: flex;
    margin-bottom: 30px;

    .urge-label {
        padding: 2px 6px;
        background: #fff3e4;
        border-radius: 5px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #ff6e00;
        line-height: 20px;
    }

    .urge-info {
        padding: 2px 6px;
        display: flex;
        flex-direction: column;
    }

    /deep/ .urge-info-time {
        .urge-info-number {
            margin-left: 5px;
        }
    }

    /deep/ .urge-info-count {
        .urge-info-number {
            margin: 0 5px;
        }
    }

    /deep/ .urge-info-time,
    /deep/ .urge-info-count {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #32404b;

        span {
            display: inline-block;
            height: 20px;
            line-height: 20px;
        }

        .urge-info-number {
            color: #ff6e00;
            font-weight: 600;

            .millisecond {
                font-size: 12px;
            }
        }
    }
}
</style>
